// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"753e7905","447":"4cc119f7","487":"c0ef6f56","692":"3eeef62d","706":"3b5561ff","856":"c9352e8b"}[chunkId] + ".chunk.css";
};